<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 ml-0 md:ml-4 aarni-font">Admission Flow</h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>
        <section class="flex-1 shadow-lg p-4 border-2  border-gray-200 h-fit bg-white">
            <h1 class="text-2xl font-bold mb-4">Admission Flow</h1>
            <img src="assets/img/admissions/admission-flow-chart.webp" alt="Admission Flow" />
        </section>
    </div>
</div>

